(() => {
  if (window.__LDJ_COLLECTION_FILTER_LOADED__) return;
  window.__LDJ_COLLECTION_FILTER_LOADED__ = true;

  const handleFilterClick = (event) => {
    const link = event.target.closest('[data-single-filter]');

    if (!link) return;

    event.preventDefault();

    const param = link.dataset.filterParam;
    const value = link.dataset.filterValue;

    if (!param) return;

    const url = new URL(window.location.href);

    /*
     * Critical:
     * remove EVERY previously selected value
     * belonging to Shop category.
     */
    url.searchParams.delete(param);

    /*
     * Apply only the newly selected category.
     * Empty value = ALL.
     */
    if (value) {
      url.searchParams.set(param, value);
    }

    /*
     * Never retain pagination when changing filters.
     */
    url.searchParams.delete('page');

    window.location.assign(url.toString());
  };

  document.addEventListener('click', handleFilterClick);
})();

